
<template>
  <div class="modal">
    <div class="modal-content select-category-modal">
      <p class="btn" v-on:click="handleSubmit(null)">x</p>
      <form @submit.prevent>
        <input type="text" id="selectProductModelSearchInput" v-model="search" class="input" placeholder="Search Product">
      </form>
      <div class="category-list">
          <div>
              
          </div>
        <div 
          v-for="item in products" 
          :key="item._id"
          v-on:click="handleSubmit(item)"
          class="category btn"
        >
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['closeModal', 'onSubmit'],
  data() {
    return {
        searchTimeout: null,
        search: ''
    }
  },
  watch: {
    search: function() {
        this.searchTimeout && clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(
            () => this.getProducts(), 500
        )
    },
  },
  mounted() {
      this.getProducts();
  },
  methods: {
    handleSubmit(product) {
        this.closeModal()
        this.onSubmit(product)
    },
    getProducts: function() {
        this.$store.dispatch("productsModule/getAll", {
            query: {
                search: this.search,
            }
        });
    }
  },
  computed: {
    products() {
        return this.$store.state.productsModule.listALlProducts || [];
    }
  }
}
</script>

<style>

</style>